import {
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * 4-star content rating used in the curation modal's Library pane. Emits `changed` and
 * lets the parent update `[stars]` (no self-mutation) — mirroring the v1 ftRating
 * behaviour when a handler returns void. Captions come from ngx TranslateService.instant.
 */
@Component({
    selector: 'ft-rating-ng',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-rating.component.html'
})
export class FtRatingComponent implements OnInit {
    readonly stars = input<number>();
    readonly disabled = input(false);
    readonly changed = output<number>();

    protected readonly values = [1, 2, 3, 4];
    protected readonly caption = signal<string>('');

    private readonly ratingItems: { [key: number]: string };

    constructor() {
        const translateSvc = inject(TranslateService);
        const translate = (key: string) => translateSvc.instant(key);
        this.ratingItems = {
            1: translate('flipto.account.rating.NotGood'),
            2: translate('flipto.account.rating.Good'),
            3: translate('flipto.account.rating.Great'),
            4: translate('flipto.account.rating.Amazing'),
        };
    }

    ngOnInit(): void {
        // v1 link fn calls setCaption() once → shows the existing rating's caption on load.
        this.setCaption();
    }

    protected rate(value: number): void {
        if (this.disabled()) return;
        this.changed.emit(value);
    }

    protected setCaption(value?: number): void {
        this.caption.set(
            (value && this.ratingItems[value]) || (this.stars() && this.ratingItems[this.stars()]) || '',
        );
    }
}
